import { SettingConst } from '@faire/web-api--source/types';

/**
 * Messenger window logo URL
 */
export const HELP_CENTER_CHAT_MESSENGER_WINDOW_LOGO_URL_230413 =
  'HELP_CENTER_CHAT_MESSENGER_WINDOW_LOGO_URL_230413' as SettingConst<
    'HELP_CENTER_CHAT_MESSENGER_WINDOW_LOGO_URL_230413',
    string,
    'HELP_CENTER' | 'RETAILER_IOS' | 'RETAILER_ANDROID'
  >;
